export { TabbedThreeTile } from './TabbedThreeTile';
